import { useContext } from "react"
import { NavLink } from "react-router-dom"
import styles from "../../styles/Sidebar-FBT.module.css"
import { UserContext } from "../../context/userContext"
import OrganizationLogo from "../../components/OrganizationLogo"

export default function FBTSidebar() {
  const userCtx = useContext(UserContext)

  return (
    <div>
      <OrganizationLogo />
      <ul className={styles.nav}>
        <li>
          <NavLink
            to={`/library/enterprise_profile/1/${userCtx.session.user.enterprise_id_stamp}`}
            className={({ isActive }) => (isActive ? styles.active : "")}
          >
            <i>E</i>
            <span>Enterprise Profile</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/enterprise/library"
            className={({ isActive }) => (isActive ? styles.active : "")}
          >
            <i>F</i>
            <span>Fields</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/library/blocks"
            className={({ isActive }) => (isActive ? styles.active : "")}
          >
            <i>B</i>
            <span>Blocks</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/library/templates"
            className={({ isActive }) => (isActive ? styles.active : "")}
          >
            <i>T</i>
            <span>Templates</span>
          </NavLink>
        </li>
        <li className={styles.disabled}>
          <div>
            <i>W</i>
            <span>Workflows</span>
          </div>
        </li>
        <li>
          <NavLink
            to="/library/gpra"
            className={({ isActive }) => (isActive ? styles.active : "")}
          >
            <i>G</i>
            <span>GPRA</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/library/documents"
            className={({ isActive }) => (isActive ? styles.active : "")}
          >
            <i>DT</i>
            <span>Document Templates</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/library/housing"
            className={({ isActive }) => (isActive ? styles.active : "")}
          >
            <i>H</i>
            <span>Housing</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/library/coordination-boards"
            className={({ isActive }) => (isActive ? styles.active : "")}
          >
            <i>CB</i>
            <span>Coordination Boards</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/library/telerecovery"
            className={({ isActive }) => (isActive ? styles.active : "")}
          >
            <i>TR</i>
            <span>Telerecovery</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/library/assessments"
            className={({ isActive }) => (isActive ? styles.active : "")}
          >
            <i>A</i>
            <span>Assessments</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/library/kiosk"
            className={({ isActive }) => (isActive ? styles.active : "")}
          >
            <i>K</i>
            <span>Kiosk</span>
          </NavLink>
        </li>
      </ul>
    </div>
  )
}
